<div class="container-fluid">
    <div class="row row-cols-3 g-2">
        @for (s of SamplerList; track s; let index = $index) {
        <div class="col justify-content-center">
            <div class="card">
                <div class="card-body p-3 ">
                    <div class="row">
                        <h4 class="col text-center"> {{s.FirstName}} {{s.LastName}}</h4>
                    </div>
                    <div class="row justify-content-center">
                        <mat-divider class="col my-2 mx-5 px-1"></mat-divider>
                    </div>

                    <div class="row">
                        <div class="col-4 text-end">Email</div>
                        <div class="col"> {{s.Email}}</div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-4 text-end"><span>Compétences</span></div>
                        <mat-chip-set class="col">

                            @for (c of s.CompetenceList; track c) {
                            <mat-chip color="accent" highlighted >
                                {{c.Name}}
                            </mat-chip>
                            }
                        </mat-chip-set>
                    </div>

                    <!-- <div class="row">
                        <div class="col-4 text-end">Téléphone</div>
                        <div class="col"> {{s.Phone}}</div>
                    </div> -->
                    @if (s.PlanningConfiguration) {

                    <div class="row">
                        <div class="col-4 text-end">Sous-traitance</div>
                        <div class="col">{{getLabLabel(s.PlanningConfiguration.SubContractingLab)}}</div>
                    </div>

                    <div class="row">
                        <div class="col-4 text-end">Adresse de départ</div>
                        <div class="col">{{s.PlanningConfiguration.AdresseDepart}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Adresse Arrivee</div>
                        <div class="col">{{s.PlanningConfiguration.AdresseArrivee}}</div>
                    </div>
                    <div class="row justify-content-center">
                        <mat-divider class="col my-2 mx-5 px-1"></mat-divider>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Longitude Depart</div>
                        <div class="col"> {{s.PlanningConfiguration.LongitudeDepart}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Longitude Arrivee</div>
                        <div class="col">{{s.PlanningConfiguration.LongitudeArrivee}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Latitude Depart</div>
                        <div class="col">{{s.PlanningConfiguration.LatitudeDepart}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Latitude Arrivee</div>
                        <div class="col">{{s.PlanningConfiguration.LatitudeArrivee}}</div>
                    </div>
                    <div class="row justify-content-center">
                        <mat-divider class="col my-2 mx-5 px-1"></mat-divider>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Duree Pause</div>
                        <div class="col">{{s.PlanningConfiguration.DureePause}} (min)</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Heure Pause Minimale</div>
                        <div class="col">{{s.PlanningConfiguration.HeurePauseMinimale}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Heure Debut Journee</div>
                        <div class="col">{{s.PlanningConfiguration.HeureDebutJournee}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-end">Amplitude Horaire Maximale</div>
                        <div class="col">{{s.PlanningConfiguration.AmplitudeHoraireMaximale}} (min)</div>
                    </div>

                    }
                    <div class="row">
                        <div class="text-end">
                            <button class="" mat-mini-fab color="primary" (click)="openUserConfigurationBox(s)">
                                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        <!-- <div class="col justify-content-center">
            <div #myCard class="card clickable tile">
                <button class="m-auto" mat-mini-fab color="primary" (click)="openAgencyBox()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div> -->
    </div>
</div>